module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    class: {
      'with-aside': _vm.showAside
    }
  }, [_c('header', {
    staticClass: "app-header"
  }, [_c('nav', {
    staticClass: "app-nav"
  }, [_c('nav-button', {
    attrs: {
      "align": "left"
    },
    on: {
      "onClick": function($event) {
        _vm.showAside = _vm.showAside !== true
      }
    }
  }, [_vm._v("메뉴")]), _vm._v(" "), _c('nav-address', {
    attrs: {
      "geocoder": _vm.geocoder,
      "marker": _vm.getAverageMarker()
    }
  }), _vm._v(" "), _c('nav-button', {
    attrs: {
      "align": "right"
    },
    on: {
      "onClick": function($event) {}
    }
  }, [_vm._v("로그인")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('aside', {
    staticClass: "app-aside"
  }, [_vm._v("\n        메뉴\n    ")]), _vm._v(" "), _c('footer', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "function-panel-wrap"
  }, [_c('function-panel', {
    attrs: {
      "listData": _vm.getPanelData()
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "function-button-wrap"
  }, [_c('function-button', {
    class: {
      active: _vm.getIsMarkersPanelVisible()
    },
    attrs: {
      "label": "사람",
      "count": _vm.getMarkersLength()
    },
    on: {
      "onClick": function($event) {
        _vm.setPanel('markers')
      }
    }
  }), _vm._v(" "), _c('function-button', {
    class: {
      active: _vm.getIsPlacesPanelVisible()
    },
    attrs: {
      "label": "장소",
      "count": _vm.getPlacesLength()
    },
    on: {
      "onClick": function($event) {
        _vm.setPanel('places')
      }
    }
  }), _vm._v(" "), _c('function-button', {
    attrs: {
      "label": "새로고침"
    },
    on: {
      "onClick": function($event) {
        _vm.showConfirm = true
      }
    }
  }), _vm._v(" "), _c('function-button', {
    attrs: {
      "label": "지도공유"
    },
    on: {
      "onClick": function($event) {}
    }
  })], 1)]), _vm._v(" "), (_vm.showIntroLayer) ? _c('intro-layer', {
    on: {
      "saveDisable": _vm.disableIntroLayer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfirm) ? _c('confirm', {
    on: {
      "onClose": function($event) {
        _vm.showConfirm = false
      },
      "onConfirm": _vm.clearMap
    }
  }, [_c('div', {
    slot: "body"
  }, [_vm._v("입력된 위치를 모두 제거하시겠습니까?")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-body"
  }, [_c('div', {
    attrs: {
      "id": "map-canvas"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25c7f483"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 50
// module chunks = 0